@if (editQuestionData.canOpenInFullView) {
  <a mat-dialog-title style="cursor: pointer; text-decoration: underline" (click)="onClickHeader()">
    {{ (editQuestionData.cwQuestion._id ? 'titles.update-question' : 'titles.create-question') | translate }}
  </a>
} @else {
  <span mat-dialog-title>
    {{ (editQuestionData.cwQuestion._id ? 'titles.update-question' : 'titles.create-question') | translate }}
  </span>
}
<mat-dialog-content>
  <app-edit-question [editQuestionData]="editQuestionData" (cancel)="onCancel()" (save)="onSave($event)"></app-edit-question>
</mat-dialog-content>
